import React from "react";
import BackButton from "../../main/BackButton";
import Video from "../../main/Video";

const Collection5Video = () => {
  return (
    <>
      <BackButton url="/allvideos" />
      <Video
        url={`https://yuriy-dmytrash19.wistia.com/medias/k8nhbwq7t3`}
        maxHeight="80%"
      />
    </>
  );
};

export default Collection5Video;
